import type { UpdateBuyerAccountInput } from '@/graphql/graphql';
import {
    GET_BUYER_AUTH_CONTEXT,
    GET_BUYER_PROFILE,
    GET_BUYER_TECHNICAL_SETTINGS,
    UPDATE_BUYER_ACCOUNT,
} from '@/graphql/queries/buyers.graphql';
import { apolloClient } from '@/lib/apollo-client';

export const updateBuyerAccount = async (input: UpdateBuyerAccountInput) => {
    const normalizedInput = {
        ...input,
        contactEmail: input.contactEmail?.toLocaleLowerCase(),
        billingEmail: input.billingEmail?.toLocaleLowerCase(),
    };
    const result = await apolloClient.mutate({
        mutation: UPDATE_BUYER_ACCOUNT,
        variables: { input: normalizedInput },
    });
    return { data: result };
};

export const getBuyerProfile = async (id: string) => {
    const response = await apolloClient.query({
        query: GET_BUYER_PROFILE,
        variables: { id },
    });
    return response.data.buyer.account;
};

export const getBuyerAuthContext = async (id: string) => {
    const response = await apolloClient.query({
        query: GET_BUYER_AUTH_CONTEXT,
        variables: { id },
    });
    return response.data.buyer.account;
};

export const getBuyerTechnicalSettings = async (id: string) => {
    const response = await apolloClient.query({
        query: GET_BUYER_TECHNICAL_SETTINGS,
        variables: { id },
    });
    return response.data.buyer.account;
};
